var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 349,
    height: 77,
    viewBox: "0 0 349 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.9598 38.8635C25.5113 38.7403 38.187 35.7249 40.4624 26.3539C41.0742 23.8315 40.7487 21.6067 40.6342 20.8702C39.8386 15.7713 36.3457 11.0302 31.4484 9.07901C28.8807 8.05683 25.9453 7.75919 22.8562 8.44465C17.1814 9.70735 14.0893 13.6217 12.9019 19.385C10.9581 28.8221 13.583 39.1071 18.0253 47.3627C25.8218 61.8506 45.5978 76.4377 61.007 70.8428C70.2289 67.4966 75.7109 58.4203 76.7597 56.6435C77.5583 55.2876 80.9789 49.2717 81.6208 40.6133C81.9825 35.7158 81.3315 31.6421 80.6775 28.8853C81.4099 31.5459 82.2175 35.6347 81.9463 40.6223C81.8378 42.5945 81.3104 49.3048 77.2298 56.7126C73.3331 63.7837 68.0892 68.0618 64.7199 70.3257C61.8086 72.2828 54.8258 77.024 45.0372 76.9999C40.2032 76.9879 25.1286 76.9548 14.6077 65.5184C7.86901 58.1918 4.6172 50.0203 4.13199 45.9226C3.19171 37.9857 2.77582 22.205 14.5715 11.3488C23.5645 3.07219 39.0821 7.81331 41.1736 20.344C41.5684 22.7161 41.1676 23.6902 41.8005 26.3088C43.4128 33.004 51.0014 36.744 57.2579 38.8666C55.6968 38.9507 50.0129 39.4528 45.8992 43.9865C40.8331 49.5664 40.6975 58.4353 44.329 63.3177C45.8901 65.4162 48.1595 66.7991 48.4819 66.9915C49.826 67.7943 52.2009 68.9277 55.299 69.1051C56.1669 69.1532 61.1245 69.3576 65.0755 66.1558C68.9632 63.005 69.7558 58.3211 70.1777 55.5942C71.9377 44.1669 66.6155 28.9664 55.1633 17.9509C49.7929 12.7859 39.483 2.87076 26.4034 4.91212C15.1984 6.65884 8.48682 16.1711 6.79612 18.5703C5.70516 20.1155 1.4106 26.4771 0.509499 35.8932C-0.00584757 41.2897 0.77772 45.7542 1.5191 48.6404C1.08211 47.2304 0.530595 45.1349 0.226209 42.5524C-1.82312 25.0641 10.7079 12.1486 11.3981 11.4601C13.1038 9.75545 17.2085 5.98841 23.6067 3.28264C33.5098 -0.905293 47.403 -1.90643 59.8195 5.20975C61.6911 6.28304 76.5065 15.1039 79.2882 32.8056C80.6263 41.3168 77.263 54.8066 68.6739 64.397C60.4826 73.5455 42.4605 70.9059 40.9235 56.3579C40.821 55.3808 40.8452 54.3766 40.7276 53.3996C40.6131 52.4616 39.9079 48.0902 36.8429 44.4465C32.473 39.2454 26.1081 38.9086 24.9568 38.8666L24.9598 38.8635Z",
    fill: "url(#paint0_linear_326_301)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M137.619 39.7311C137.619 51.9863 128.887 59.4354 118.315 59.4354C107.743 59.4354 99.0107 51.9863 99.0107 39.7311C99.0107 27.4759 107.662 19.9467 118.315 19.9467C128.967 19.9467 137.619 27.3959 137.619 39.7311ZM132.093 39.7311C132.093 28.1961 126.407 21.1471 118.315 21.1471C110.223 21.1471 104.537 28.1961 104.537 39.7311C104.537 51.2661 110.223 58.2351 118.315 58.2351C126.407 58.2351 132.093 51.186 132.093 39.7311Z",
    fill: "url(#paint1_linear_326_301)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M182.396 39.7311C182.396 51.6662 174.787 59.4354 164.695 59.4354C158.928 59.4354 154.122 56.3922 151.397 51.186L147.231 58.6352H146.191V8.5718C146.191 5.44858 145.391 3.84578 142.425 3.52569V2.56542L150.754 2.24938e-09H151.475V28.1961C154.198 22.9099 158.924 19.9467 164.69 19.9467C174.782 19.9467 182.391 27.716 182.391 39.7311H182.396ZM176.868 39.7311C176.868 28.5962 172.382 21.1471 164.692 21.1471C157.003 21.1471 151.477 28.1161 151.477 39.7311C151.477 51.3461 157.003 58.2351 164.692 58.2351C172.382 58.2351 176.868 50.7859 176.868 39.7311Z",
    fill: "url(#paint2_linear_326_301)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M200.018 58.6328H187.202V57.6726C190.165 57.4325 190.968 55.7497 190.968 52.6264V8.5718C190.968 5.44858 190.168 3.84578 187.202 3.52569V2.56542L195.532 2.24938e-09H196.252V52.6264C196.252 55.7497 197.052 57.4325 200.018 57.6726V58.6328Z",
    fill: "url(#paint3_linear_326_301)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M218.439 58.6328H205.624V57.6726C208.587 57.4325 209.39 55.7497 209.39 52.6265V28.5162C209.39 25.393 208.589 23.7101 205.624 23.4701V22.5098L213.953 19.9467H214.594V52.6288C214.594 55.752 215.394 57.4349 218.439 57.6749V58.6352V58.6328ZM207.384 9.45205C207.384 6.96901 209.227 5.60627 211.31 5.60627C213.393 5.60627 215.316 6.96901 215.316 9.45205C215.316 11.9351 213.473 13.3779 211.31 13.3779C209.147 13.3779 207.384 11.9375 207.384 9.45205Z",
    fill: "url(#paint4_linear_326_301)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M263.694 75.8565V76.8167H250.879V75.8565C253.842 75.5364 254.645 73.9336 254.645 70.8103V51.186C251.921 56.4722 247.195 59.4354 241.427 59.4354C231.335 59.4354 223.645 51.6662 223.645 39.6511C223.645 27.6359 231.335 19.9467 241.427 19.9467C247.193 19.9467 251.919 22.9899 254.645 28.1961L258.81 20.827H259.851V70.8103C259.851 73.9336 260.651 75.5364 263.697 75.8565H263.694ZM254.642 39.6511C254.642 28.1161 249.116 21.1471 241.424 21.1471C233.733 21.1471 229.169 28.5962 229.169 39.6511C229.169 50.7059 233.735 58.2351 241.424 58.2351C249.114 58.2351 254.642 51.2661 254.642 39.6511Z",
    fill: "url(#paint5_linear_326_301)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M308.229 57.6726V58.6328H299.177V52.384C296.774 56.6299 292.928 59.433 287.322 59.433C278.75 59.433 271.943 54.787 271.943 44.2147V28.5138C271.943 25.3906 271.143 23.7078 268.098 23.4677V22.5075L276.427 19.9444H277.147V43.7346C277.147 51.2637 279.95 58.0727 288.442 57.9926C294.289 57.9926 299.175 52.3064 299.175 46.9378V28.5138C299.175 25.3906 298.374 23.7078 295.409 23.4677V22.5075L303.738 19.9444H304.378V52.6264C304.378 55.8297 305.179 57.4325 308.224 57.6726H308.229Z",
    fill: "url(#paint6_linear_326_301)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M349 56.8723C348.44 57.9126 346.837 59.4354 344.514 59.4354C340.991 59.4354 338.908 57.7526 338.908 54.1492V50.3034C337.545 55.1095 333.382 59.4354 326.173 59.4354C319.124 59.5154 314.078 55.2695 313.918 49.4232C313.678 42.7743 318.884 38.1283 326.253 37.4081C334.102 36.6879 338.908 36.4478 338.908 36.4478V32.2819C338.908 23.4701 336.265 21.067 330.096 21.067C326.09 21.067 322.727 23.31 322.807 27.0758C322.807 30.279 320.644 31.2416 318.801 30.5214C316.798 29.6412 316.798 27.3182 317.601 25.7154C319.604 21.8696 324.49 20.1892 329.776 19.9491C336.905 19.709 344.194 22.5922 344.194 33.2446V54.2316C344.194 57.4348 346.917 57.915 348.6 56.3145L349 56.8747V56.8723ZM338.906 43.9746V37.5658C338.906 37.5658 334.82 37.7258 328.493 38.526C322.245 39.3263 318.561 43.4121 318.801 49.0184C318.961 54.3045 322.807 57.5101 328.333 57.3478C335.142 57.1877 338.906 50.8589 338.906 43.9723V43.9746Z",
    fill: "url(#paint7_linear_326_301)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_326_301",
    x1: -17,
    y1: 38,
    x2: 422,
    y2: 20.0006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9D9D9D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_326_301",
    x1: -17,
    y1: 38,
    x2: 422,
    y2: 20.0006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9D9D9D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_326_301",
    x1: -17,
    y1: 38,
    x2: 422,
    y2: 20.0006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9D9D9D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_326_301",
    x1: -17,
    y1: 38,
    x2: 422,
    y2: 20.0006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9D9D9D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_326_301",
    x1: -17,
    y1: 38,
    x2: 422,
    y2: 20.0006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9D9D9D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_326_301",
    x1: -17,
    y1: 38,
    x2: 422,
    y2: 20.0006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9D9D9D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_326_301",
    x1: -17,
    y1: 38,
    x2: 422,
    y2: 20.0006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9D9D9D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_326_301",
    x1: -17,
    y1: 38,
    x2: 422,
    y2: 20.0006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9D9D9D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.6bfc5a2efb08ed52b6b547f8aae6a327.svg";
export { ForwardRef as ReactComponent };